import { render, staticRenderFns } from "./PersonalDataCategories.vue?vue&type=template&id=db83349a&"
import script from "./PersonalDataCategories.vue?vue&type=script&lang=js&"
export * from "./PersonalDataCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports